<template>
  <div class="flex items-center justify-center gap-2 w-full">
    <FlagIcon class="icon" style="width: 24px; height: 24px" />
    <div class="w-full flex justify-center" v-if="isLoading">Calculando...</div>
    <div
      v-else
      class="rounded-full w-full h-6 overflow-hidden relative"
      :style="{
        border: '1px solid #b8c9d9',
      }"
    >
      <span class="progress-text absolute z-50"> {{ progressDark }}% </span>
      <div class="h-6 rounded-full absolute w-full"></div>
      <div
        class="h-6 rounded-full absolute"
        :style="{
          width: progressLight + '%',
          backgroundColor: performanceProgressBar,
          zIndex: 40,
        }"
      ></div>
      <div
        class="h-6 main-primary rounded-full absolute"
        :style="{ width: progressDark + '%', zIndex: 30 }"
      ></div>
    </div>
    <AwardIcon
      style="width: 24px; height: 24px"
      :class="{
        golden: progressLight >= progressDark || progressLight === 100,
      }"
    />
  </div>
</template>

<script>
import { FlagIcon, AwardIcon } from 'vue-feather-icons';

export default {
  name: 'ProgressBar',
  data() {
    return {};
  },
  components: {
    FlagIcon,
    AwardIcon,
  },
  props: ['percentageWorkingDay', 'percentageTarget', 'isLoading'],
  computed: {
    progressDark() {
      return Math.floor(this.percentageWorkingDay);
    },
    progressLight() {
      const target = this.percentageTarget;
      const isNumber = !isNaN(parseFloat(target)) && isFinite(target);
      return isNumber ? Math.floor(target) : 0;
    },
    performanceProgressBar() {
      const PERFORMANCE_VALUE = Math.floor(this.progressDark * 0.9);

      if (this.progressLight >= this.progressDark) {
        return '#5ADC96';
      }

      if (this.progressLight < PERFORMANCE_VALUE) {
        return '#D96977';
      }

      return '#EECE70';
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap');

.main-primary {
  background-color: #b8c9d9;
}
.accent-secondary {
  background-color: #0c90cf;
}
.progress-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #434343;
  white-space: nowrap;
  z-index: 50; /* Garante que o texto esteja acima das barras de progresso */
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  padding: 0;
  line-height: initial;
}
.golden {
  color: #d7a546;
}
</style>
